module.exports = __webpack_public_path__ + "static/media/DiegoRossiniVieira.f8bca703.jpg";